<template>

    <div v-if="showModal && !showCompletionModal" class="bg-white rounded-lg w-full max-w-4xl max-h-128 px-6 py-10 md:p-12 items-center relative">
      
        <ErrorMessage :message="errorMessage" @clear-message="errorMessage = ''" />
      
        <!-- ヘッダー -->
        <div class="self-stretch pb-4 border-b border-gray-300 flex justify-between items-center">
            <div class="flex-1 text-gray-700 text-lg font-semibold leading-7 break-words">チームメンバーを追加する</div>

            <!-- モーダルを閉じるボタン -->
            <button
                v-if="!isUploading"
                @click="$emit('close-modal')"
                class="link-styles--gray"
            >
                <i class="fa-light fa-xmark text-3xl"></i>
            </button>
        </div>

        <div class="w-full px-4 py-12 rounded-lg flex flex-col gap-8 items-stretch">
            <div class="flex flex-col lg:flex-row gap-8">
                <div class="w-24 h-24 bg-gray-100 rounded-full flex justify-center items-center shrink-0 mx-auto lg:mx-0">
                    <i class="fa-solid fa-user text-4xl text-gray-500"></i>
                </div>
                <div class="w-full lg:flex-1 lg:min-w-0">
                    <label class="block text-gray-700 text-sm font-semibold mb-3">メールアドレス</label>
                    <input
                        v-model="email"
                        class="block w-full p-2 rounded outline outline-1 outline-offset-[-1px]"
                        :class="validationErrorMessage?.length == 0 ? 'outline-gray-300': 'outline-red-600'"
                        placeholder="例）aaaa@example.com"
                    />
                    <p class="mt-3 text-gray-700 text-xs">※ECHOESに登録済みのメールアドレスのみ招待できます</p>
                    <div
                        v-if="validationErrorMessage"
                        class="mt-2 text-sm font-semibold text-red-600 w-full leading-5"
                    >
                          {{ validationErrorMessage }}
                    </div>
                </div>
            </div>
        </div>

        <!-- ボタン群 -->
        <div
            class="flex flex-col-reverse lg:flex-row
                   justify-center lg:justify-end
                   items-stretch lg:items-start
                   gap-3 pt-4 mt-8 border-t border-gray-300"
        >
            <button
                data-propaty="secondary"
                data-status="default"
                class="btn-secondary w-full lg:w-auto"
                @click="$emit('close-modal')"
            >
                キャンセル
            </button>
            <button
                class="btn-primary w-full lg:w-auto"
                @click="sendInvitation"
            >
                メンバーを追加する
            </button>
        </div>
    </div>

    <div v-else-if="showCompletionModal" class="w-[688px] pt-24 pb-12 px-12 bg-white shadow-sm rounded-lg flex flex-col justify-start items-center gap-4 inline-flex">
        <!-- 緑の丸アイコン -->
        <div class="w-20 h-20 relative overflow-hidden">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_5276_3004)">
                    <path d="M40 5C49.2826 5 58.185 8.68749 64.7487 15.2513C71.3125 21.815 75 30.7174 75 40C75 49.2826 71.3125 58.185 64.7487 64.7487C58.185 71.3125 49.2826 75 40 75C30.7174 75 21.815 71.3125 15.2513 64.7487C8.68749 58.185 5 49.2826 5 40C5 30.7174 8.68749 21.815 15.2513 15.2513C21.815 8.68749 30.7174 5 40 5ZM40 80C50.6087 80 60.7828 75.7857 68.2843 68.2843C75.7857 60.7828 80 50.6087 80 40C80 29.3913 75.7857 19.2172 68.2843 11.7157C60.7828 4.21427 50.6087 0 40 0C29.3913 0 19.2172 4.21427 11.7157 11.7157C4.21427 19.2172 0 29.3913 0 40C0 50.6087 4.21427 60.7828 11.7157 68.2843C19.2172 75.7857 29.3913 80 40 80ZM56.7656 31.7656C57.7344 30.7969 57.7344 29.2031 56.7656 28.2344C55.7969 27.2656 54.2031 27.2656 53.2344 28.2344L35 46.4688L26.7656 38.2344C25.7969 37.2656 24.2031 37.2656 23.2344 38.2344C22.2656 39.2031 22.2656 40.7969 23.2344 41.7656L33.2344 51.7656C34.2031 52.7344 35.7969 52.7344 36.7656 51.7656L56.7656 31.7656Z" fill="#10B981"/>
                </g>
                <defs>
                    <clipPath id="clip0_5276_3004">
                        <rect width="80" height="80" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        </div>

        <!-- メッセージ -->
        <div class="self-stretch pt-8 pb-8 flex flex-col justify-start items-center gap-4">
            <p class="self-stretch text-center text-gray-700 text-lg font-semibold leading-7 break-words">招待を送信しました</p>
        </div>

        <!-- 閉じるボタン -->
        <div class="inline-flex justify-center items-center gap-2.5">
            <button
                data-propaty="secondary"
                data-status="default"
                class="btn-secondary"
                @click="$emit('close-modal')"
            >
                閉じる
            </button>
        </div>
    </div>
</template>




<script setup>
import { ref, defineEmits, defineProps } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import ErrorMessage from './ErrorMessage.vue';

defineProps({
    showModal: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['close-modal', 'load-member']);
const store = useStore();
const accessToken = store.state.accessToken;
const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;

const showCompletionModal = ref(false);
const email = ref('');
const errorMessage = ref('');
const validationErrorMessage = ref('');

const validateEmail = () => {
    const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    const result = regex.test(email.value);

    validationErrorMessage.value = result ? "" : "メールアドレスが正しくありません";
    return result;
};

const sendInvitation = async () => {
    if (!validateEmail()) {
        return;
    }
    try {
        const response = await axios.post(
            `${apiEndpoint}/member-invitations/`,
            { email: email.value },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        if ([200, 201].includes(response.status)) {
            console.log('メンバー招待に成功しました。');
            showCompletionModal.value = true;
            emit('load-member');
        }
    } catch (error) {
        if (error.response?.status === 400) {
            errorMessage.value = error.response.data.error;
        } else {
            console.error('メンバー招待に失敗しました。', error);
            errorMessage.value = 'メンバー招待に失敗しました。しばらく経ってから再度お試しください。';
        }
    }
};
</script>
